var _class;
import { runInAction } from "mobx";
import { observer } from "mobx-react";
import Slider from "rc-slider";
import { Component } from "react";
import { withTranslation } from "react-i18next";
import styled, { withTheme } from "styled-components";
import CommonStrata from "../../../Models/Definition/CommonStrata";
import hasTraits from "../../../Models/Definition/hasTraits";
import Box from "../../../Styled/Box";
import Spacing from "../../../Styled/Spacing";
import Text from "../../../Styled/Text";
import OpacityTraits from "../../../Traits/TraitsClasses/OpacityTraits";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let OpacitySection = observer(_class = class OpacitySection extends Component {
  constructor(props) {
    super(props);
    this.changeOpacity = this.changeOpacity.bind(this);
  }
  changeOpacity(value) {
    const item = this.props.item;
    if (hasTraits(item, OpacityTraits, "opacity")) {
      runInAction(() => {
        item.setTrait(CommonStrata.user, "opacity", value / 100.0);
      });
    }
  }
  render() {
    const item = this.props.item;
    const {
      t
    } = this.props;
    if (!hasTraits(item, OpacityTraits, "opacity") || hasTraits(item, OpacityTraits, "disableOpacityControl") && item.disableOpacityControl) {
      return null;
    }
    return /*#__PURE__*/_jsxs(Box, {
      verticalCenter: true,
      paddedHorizontally: 3,
      paddedVertically: 2,
      children: [/*#__PURE__*/_jsx(StyledLabel, {
        medium: true,
        htmlFor: "opacity",
        children: t("workbench.opacity", {
          opacity: Math.round(item.opacity * 100)
        })
      }), /*#__PURE__*/_jsx(Spacing, {
        right: 3
      }), /*#__PURE__*/_jsx(Slider, {
        min: 0,
        max: 100,
        value: item.opacity * 100 | 0,
        onChange: this.changeOpacity
      })]
    });
  }
}) || _class;
const StyledLabel = styled(Text).attrs({
  as: "label"
}).withConfig({
  displayName: "OpacitySection__StyledLabel",
  componentId: "sc-a6qgxh-0"
})(["white-space:nowrap;flex-basis:50%;"]);
export default withTranslation()(withTheme(OpacitySection));